import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/navigation/week/dateTimeInput/styles.scss';export default {
  "root": "_root_1fb7m_1",
  "inputBox": "_inputBox_1fb7m_5",
  "arrow": "_arrow_1fb7m_14",
  "leftArrowWrapper": "_leftArrowWrapper_1fb7m_22",
  "rightArrowWrapper": "_rightArrowWrapper_1fb7m_35",
  "calendarButton": "_calendarButton_1fb7m_48",
  "leftArrow": "_leftArrow_1fb7m_22",
  "rightArrow": "_rightArrow_1fb7m_35",
  "title": "_title_1fb7m_74",
  "calendarIcon": "_calendarIcon_1fb7m_85",
  "dateTimeInput": "_dateTimeInput_1fb7m_92"
};